module.exports = __webpack_public_path__ + "img/papaFinance.a159b2d9.png";